<template>
  <div>
    <section class="home-busca">
      <div class="container destaques">
        <div class="row">
          <div class="col-6 search-menu">
            <form action="#"  method = "get" enctype="multipart/form-data" >
              <div class="search">
                <input type="text" class="search-term" name="texto" placeholder="O que você quer estudar hoje?" v-model="termoPesquisa"/>
                <button type="submit" class="btn btn-primary" @click="buscaGeralPlataforma">
                  Buscar
                </button>
              </div>
              <div>
                <table class="tags-buscados">
                  <tr>
                    <td>Mais buscados</td>
                    <td>
                      <div class="tags row">
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Farmacologia')">Farmacologia</a>
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Semiologia')">Semiologia</a>
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Pediatria')">Pediatria</a>
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Suseme')">Suseme</a>
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Anatomia')">Anatomia</a>
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Fisiologia')">Fisiologia</a>
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Embriologia')">Embriologia</a>
                        <a class="tags-busca" @click="aplicarTermoPesquisaMaisBuscados('Imunologia')">Imunologia</a>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </form>
          </div>
          <div class="col-6 utilizacao-plataforma">
            <fieldset>
              <legend>Seus números no jaleko</legend>
              <div class="row">
                <div class="d-flex align-items-center mt-md-3 mb-md-4 ml-md-4 p-1 p-md-0">
                    <div>
                      <span class="numeros-jaleko" id="qtd-topicos">
                        <animated-number :value="qtdeTopicosConcluidos" :formatValue="formatIntegerNumber" :duration="800"/>
                      </span>
                      <p>Tópicos concluídos</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mt-md-3 mb-md-4 ml-md-4 p-1 p-md-0">
                    <div>
                      <span class="numeros-jaleko" id="qtd-videos">
                        <animated-number :value="qtdeVideosAssistidos" :formatValue="formatIntegerNumber" :duration="800"/>
                      </span>
                      <p>Vídeos assistidos</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mt-md-3 mb-md-4 ml-md-4 p-1 p-md-0">
                    <div>
                      <span class="numeros-jaleko" id="qtd-questoes">
                        <animated-number :value="qtdeQuestoesRespondidas" :formatValue="formatIntegerNumber" :duration="800"/>
                      </span>
                      <p>Questões respondidas</p>
                    </div>
                  </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </section>

    <section class="destaques-home">
      <div class="container destaques">
        <div class="d-flex justify-content-between destaques">
          <div class="destaques-curso col-8">
            <destaques-carousel :banners="destaques.carrossel" v-if="destaques.carrossel && destaques.carrossel.length" />
          </div>
          <div class="destaques-ferramentas col-4">
            <fieldset class="mb-md-4" v-if="destaques.simulados.length">
              <legend>Simulado em destaque</legend>
              <div class="destaques-simulado mt-md-3 mb-md-3 ml-md-5">
              <img class="icone-destaque" :src="`${baseFilesUrl}desenvolvimento/topicos-imagem/604a6f5cd2bad_illustration.png`">
                <span class="d-flex align-items-center mb-md-2 mr-md-5">{{ simuladoDestaque }}</span>
                <div>
                  <a class="btn btn-comecar" @click="irParaSimuladoDestaque" href="javascript:void(0)">Começar</a>
                </div>
              </div>
            </fieldset>
            <fieldset class="mb-md-4" v-if="$configEmpresa.jaleklinico && destaques.jaleklinicos.length">
              <legend>Caso clínico em destaque</legend>
              <div class="destaques-jaleklinico  mt-md-3 mb-md-3 ml-md-5">
              <img class="icone-destaque" :src="`${baseFilesUrl}desenvolvimento/topicos-imagem/604a6f5215dd9_Robozinho.png`">
              <span class="d-flex align-items-center mb-md-2 mr-md-5">{{ jaleklinicoDestaque }}</span>
                <div>
                  <a class="btn" :href="obterCaminhoCompletoJaleklinico()">Pegar Caso</a>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ResumoHomeAPI from '@/api/resumo-home-api'
import DestaquesAPI from '@/api/destaques-api'

import AnimatedNumber from 'animated-number-vue'
import DestaquesCarousel from '@/modules/Home/components/DestaquesCarousel'

export default {
  name: 'HomeApp',
  components: {
    DestaquesCarousel,
    AnimatedNumber
  },
  data () {
    return {
      termoPesquisa: '',
      qtdeTopicosConcluidos: 0,
      qtdeVideosAssistidos: 0,
      qtdeQuestoesRespondidas: 0,
      temAcessoJaleklinico: false,
      destaques: {
        carrossel: [],
        simulados: [],
        jaleklinicos: []
      }
    }
  },

  async mounted () {
    this.termoPesquisa = this.$route.query.q
    await ResumoHomeAPI.obterEstatisticasHome().then(data => {
      this.qtdeTopicosConcluidos = data.topicos_concluidos
      this.qtdeVideosAssistidos = data.videos_assistidos
      this.qtdeQuestoesRespondidas = data.questoes_respondidas
    })

    await DestaquesAPI.listarDestaquesHome().then(data => {
      this.destaques.carrossel = data.carrossel
      this.destaques.simulados = data.simulados
      this.destaques.jaleklinicos = data.jaleklinicos
    })
  },

  computed: {
    simuladoDestaque: function () {
      return this.destaques.simulados[0]['titulo']
    },
    jaleklinicoDestaque: function () {
      return this.destaques.jaleklinicos[0]['titulo']
    },
    baseFilesUrl: function () {
      return process.env.VUE_APP_BASE_FILES_URL
    }
  },

  methods: {
    formatIntegerNumber (value) {
      return Number(value).toFixed(0)
    },

    buscaGeralPlataforma: function () {
      this.$store.dispatch('buscaGeralPlataforma', this.termoPesquisa)
      this.$router.push(`/busca?q=${this.termoPesquisa}`)
    },

    aplicarTermoPesquisaMaisBuscados: function (termoMaisBuscado) {
      this.termoPesquisa = termoMaisBuscado
      this.buscaGeralPlataforma()
    },

    irParaSimuladoDestaque: function () {
      this.$router.push({ name: 'simulado-prova', params: { simulado: this.destaques.simulados[0]['simulados']['id'] } })
    },

    obterCaminhoCompletoJaleklinico: function (destaques) {
      return `/jaleklinico/${this.destaques.jaleklinicos[0]['jaleklinicos']['especialidades']['especialidade']}/casoclinico-${this.destaques.jaleklinicos[0]['jaleklinicos']['id']}`
    }
  }
}
</script>

<style>

</style>
